export const cashMessages = {
  kk: {
    cash: {
      header: {
        quickSale: 'Жылдам сату · сома және төлем',
        parallelSales: 'Параллельді сатулар · жылдам төлем',
        online: 'Онлайн',
        paperWidth: 'Қағаз',
        scale: 'Таразы',
        touchScreen: 'Сенсорлы моноблок',
        touchScreenOn: 'Сенсорлы моноблок қосулы',
        touchScreenOff: 'Сенсорлы моноблок өшірулі',
      },
      actions: {
        adminPanel: 'Админ панелі',
        logout: 'Шығу',
        add: 'қосу',
        cancel: 'Бас тарту',
        done: 'Дайын',
        save: 'Сақтау',
        saving: 'Сақталуда...',
        select: 'Таңдау',
      },
      catalog: {
        categories: 'Санаттар',
        products: 'Тауарлар',
        searchPlaceholder: 'Тауарды табу...',
        loadingProducts: 'Тауарлар жүктелуде...',
        noResults: 'Ештеңе табылмады',
        noProductsSelected: 'Тауарлар таңдалмады',
        tryAnotherSearch: 'Басқа сұранысты қолданып көріңіз',
        selectCategoryOrSearch: 'Санатты таңдаңыз немесе іздеуді пайдаланыңыз',
        soldTogether: 'Бірге',
        inStock: 'Қалдық: {quantity}',
      },
      searchKeyboard: {
        open: 'Пернетақта',
        done: 'Дайын',
        empty: 'Іздеу...',
        space: 'Бос орын',
      },
      scanner: {
        openCamera: 'Штрихкодты камерамен сканерлеу',
        title: 'Штрихкодты сканерлеу',
        close: 'Сканерді жабу',
        hint: 'Камераны тауардың штрихкодына бағыттаңыз.',
        connecting: 'Камера қосылуда...',
      },
      quickSale: {
        title: 'Жылдам сату',
        hint: 'Чек сомасын енгізіңіз. Тауарлар қажет емес — қоймадан есептен шығарылмайды. Бонус есептеуге болады.',
        amountLabel: 'Чек сомасы, ₸',
        paymentTypeHint: 'Төлем түрі оң жақта',
        bonusHint: 'Телефон бойынша бонус — міндетті емес',
        loanHint: 'Қарыз да қолжетімді',
      },
      sales: {
        newSale: 'Жаңа сату',
        receipt: 'Чек {number}',
      },
      receipt: {
        title: 'Төлем сәтті өтті',
        number: 'Чек №{number}',
        quickSale: 'Жылдам сату',
        quantity: '{count} × {price}',
        payment: 'Төлем',
        cashier: 'Кассир',
        total: 'Жиыны',
        print: 'Басып шығару',
        printPrinter: 'Принтер',
        autoPrint: 'Автобасып шығару',
        saveImage: 'Сурет ретінде сақтау',
        close: 'Жабу',
      },
      cart: {
        title: 'Себет',
        currentReceipt: 'Ағымдағы чек',
        addProductsLeft: 'Тауарларды сол жақтан қосыңыз',
        positions: '{count} позиция',
        empty: 'Себет бос',
        emptyHint: 'Сатуды бастау үшін тауарды басыңыз',
        weightOrLiter: 'кг / литр',
        unitCount: '₸/дана',
        unitKg: '₸/кг',
        unitLiter: '₸/л',
      },
      modifiers: {
        title: 'Модификаторлар',
        subtitle: '«{name}» үшін қосымшаларды таңдаңыз',
        none: 'Қосымшасыз',
        add: 'Себетке қосу',
        selected: '+{amount} ₸',
      },
      qtyModal: {
        title: 'Санын енгізіңіз',
        autoWeight: 'Салмақты автоматты алу',
      },
      payment: {
        title: 'Төлем',
        amountAndMethod: 'Сома және төлем тәсілі',
        due: 'Барлығы',
        was: 'Болды',
        type: 'Төлем түрі',
        amount: 'Сома',
        change: 'Қайтарым',
        processing: 'Төлем жасалуда...',
        pay: 'Төлеу',
      },
      discount: {
        none: 'Жеңілдіксіз',
        label: 'Жеңілдік',
        receipt: 'Чек жеңілдігі',
      },
      scale: {
        read: 'Таразыдан оқу',
        label: 'Таразы',
        stable: 'тұрақты',
        unstable: 'тұрақсыз',
        offline: 'жоқ',
        empty: '0 кг',
      },
      bonus: {
        accrue: 'Бонус жинау',
        phoneOrCard: 'Телефон немесе карта №',
        newClient: 'Жаңа клиент',
        card: 'карта {number}',
        balance: 'Бонус: {amount} ₸',
        clientNotFound: 'Клиент табылмады',
        redeemAll: 'Барлығын есептен шығару',
        redeemPart: 'Ішінара есептен шығару',
        redeem: 'Бонусты есептен шығару',
        clientDetails: 'Т.А.Ә., телефон және карта нөмірі',
        fullName: 'Т.А.ӘА',
        fullNamePlaceholder: 'Ахметов Асан',
        phone: 'Телефон',
        cardNumber: 'Карта нөмірі',
        generating: 'Жасалуда...',
        generateAnother: 'Басқасын жасау',
      },
      loan: {
        title: 'Қарызды рәсімдеу',
        until: '{date} дейін',
        fillDebtorDetails: 'Борышкер деректерін толтырыңыз',
        savedAfterPayment: 'Деректер төлемнен кейін ғана базаға жіберіледі',
        debtorName: 'Борышкердің аты',
        debtorNamePlaceholder: 'Клиенттің аты кім',
        whatsappPhone: 'WhatsApp нөмірі',
        phonePlaceholder: '8 (XXX) XXX-XX-XX',
        extraPhone: 'Қосымша нөмір',
        addPhone: 'Нөмір қосу',
        removePhone: 'Нөмірді өшіру',
        amount: 'Қарыз сомасы',
        returnDate: 'Қайтару күні',
        selectDate: 'Күнді таңдау',
        totalDebt: 'Қарыздың жалпы сомасы',
        returnBy: 'Қайтару мерзімі',
      },
      notifications: {
        cameraNotSupported: 'Бұл браузер камераны қолдамайды',
        barcodeNotFound: 'Штрихкод бойынша тауар табылмады',
        enterDebtorName: 'Борышкердің атын көрсетіңіз',
        enterDebtorPhone: 'WhatsApp нөмірін көрсетіңіз',
        enterDebtAmount: 'Қарыз сомасын көрсетіңіз',
        enterReturnDate: 'Қайтару күнін көрсетіңіз',
        productsLoadFailed: 'Тауарларды жүктеу мүмкін болмады',
        paymentTypesLoadFailed: 'Төлем түрлерін жүктеу мүмкін болмады',
        amountExceedsBonus: 'Сома бонустан асып кетті',
        enterFullName: 'Т.А.Ә. көрсетіңіз',
        enterPhone: 'Телефонды көрсетіңіз',
        waitForCardNumber: 'Карта нөмірін күтіңіз',
        clientAdded: 'Клиент қосылды',
        invalidPayment: 'Төлем қате',
        enterSaleAmount: 'Сату сомасын көрсетіңіз',
        dueTooHigh: 'Сома тауарлардан артық болмауы керек ({max})',
        selectProducts: 'Тауарларды таңдаңыз',
        enterWeightOrLiter: 'Салмақты немесе литрді көрсетіңіз',
        selectPaymentType: 'Төлем түрін таңдаңыз',
        enterDebtReturnDate: 'Қарызды қайтару күнін көрсетіңіз',
        findOrAddBonusClient: 'Бонус-клиентті табыңыз немесе қосыңыз',
        clientPhoneMissing: 'Клиентте телефон көрсетілмеген',
        paymentSucceeded: 'Төлем өтті',
        insufficientStock: 'Қоймада жеткіліксіз',
        scaleZeroWeight: 'Таразы 0 көрсетті. Тауарды табақшаға қойыңыз',
        weightRead: 'Салмақ: {value} {unit} ({stability})',
        weightReadFailed: 'Салмақты алу мүмкін болмады. ves_agent.py іске қосыңыз',
        weightAutoFilled: 'Салмақ таразыдан қойылды: {value} {unit}',
        noStock: 'Қоймада жоқ',
        onlyInStock: 'Қоймада тек {quantity}',
        noStockRestock: 'Қоймада жоқ. Алдымен қалдықты толтырыңыз',
      },
    },
  },
  ru: {
    cash: {
      header: {
        quickSale: 'Быстрая продажа · сумма и оплата',
        parallelSales: 'Параллельные продажи · быстрая оплата',
        online: 'Онлайн',
        paperWidth: 'Бумага',
        scale: 'Весы',
        touchScreen: 'Сенсорный моноблок',
        touchScreenOn: 'Сенсорный моноблок включён',
        touchScreenOff: 'Сенсорный моноблок выключен',
      },
      actions: {
        adminPanel: 'Админ-панель',
        logout: 'Выход',
        add: 'добавить',
        cancel: 'Отмена',
        done: 'Готово',
        save: 'Сохранить',
        saving: 'Сохранение...',
        select: 'Выбрать',
      },
      catalog: {
        categories: 'Категории',
        products: 'Товары',
        searchPlaceholder: 'Найти товар...',
        loadingProducts: 'Загрузка товаров...',
        noResults: 'Ничего не найдено',
        noProductsSelected: 'Товары не выбраны',
        tryAnotherSearch: 'Попробуйте другой запрос',
        selectCategoryOrSearch: 'Выберите категорию или воспользуйтесь поиском',
        soldTogether: 'Вместе',
        inStock: 'Остаток: {quantity}',
      },
      searchKeyboard: {
        open: 'Клавиатура',
        done: 'Готово',
        empty: 'Поиск...',
        space: 'Пробел',
      },
      scanner: {
        openCamera: 'Сканировать штрихкод камерой',
        title: 'Сканировать штрихкод',
        close: 'Закрыть сканер',
        hint: 'Наведите камеру на штрихкод товара.',
        connecting: 'Подключаем камеру...',
      },
      quickSale: {
        title: 'Быстрая продажа',
        hint: 'Введите сумму чека. Товары не нужны — склад не списывается. Можно начислить бонус.',
        amountLabel: 'Сумма чека, ₸',
        paymentTypeHint: 'Тип оплаты справа',
        bonusHint: 'Бонус по телефону — по желанию',
        loanHint: 'Қарыз тоже доступен',
      },
      sales: {
        newSale: 'Новая продажа',
        receipt: 'Чек {number}',
      },
      receipt: {
        title: 'Оплата прошла',
        number: 'Чек №{number}',
        quickSale: 'Быстрая продажа',
        quantity: '{count} × {price}',
        payment: 'Оплата',
        cashier: 'Кассир',
        total: 'Итого',
        print: 'Распечатать',
        printPrinter: 'Принтер',
        autoPrint: 'Автопечать',
        saveImage: 'Сохранить как фото',
        close: 'Закрыть',
      },
      cart: {
        title: 'Корзина',
        currentReceipt: 'Текущий чек',
        addProductsLeft: 'Добавляйте товары слева',
        positions: '{count} поз.',
        empty: 'Корзина пуста',
        emptyHint: 'Нажмите на товар, чтобы начать продажу',
        weightOrLiter: 'кг / литр',
        unitCount: '₸/шт',
        unitKg: '₸/кг',
        unitLiter: '₸/л',
      },
      modifiers: {
        title: 'Модификаторы',
        subtitle: 'Выберите дополнения для «{name}»',
        none: 'Без дополнений',
        add: 'В корзину',
        selected: '+{amount} ₸',
      },
      qtyModal: {
        title: 'Введите количество',
        autoWeight: 'Автополучение веса',
      },
      payment: {
        title: 'Оплата',
        amountAndMethod: 'Сумма и способ оплаты',
        due: 'К оплате',
        was: 'Было',
        type: 'Тип оплаты',
        amount: 'Сумма',
        change: 'Сдача',
        processing: 'Оплата...',
        pay: 'Оплатить',
      },
      discount: {
        none: 'Без скидки',
        label: 'Скидка',
        receipt: 'Скидка на чек',
      },
      scale: {
        read: 'Считать с весов',
        label: 'Весы',
        stable: 'стабилен',
        unstable: 'нестабилен',
        offline: 'нет связи',
        empty: '0 кг',
      },
      bonus: {
        accrue: 'Накопить бонус',
        phoneOrCard: 'Телефон или № карты',
        newClient: 'Новый клиент',
        card: 'карта {number}',
        balance: 'Бонус: {amount} ₸',
        clientNotFound: 'Клиент не найден',
        redeemAll: 'Списать весь',
        redeemPart: 'Списать частично',
        redeem: 'Списать бонус',
        clientDetails: 'ФИО, телефон и номер карты',
        fullName: 'ФИО',
        fullNamePlaceholder: 'Иванов Иван',
        phone: 'Телефон',
        cardNumber: 'Номер карты',
        generating: 'Генерация...',
        generateAnother: 'Сгенерировать другой',
      },
      loan: {
        title: 'Оформление долга',
        until: 'до {date}',
        fillDebtorDetails: 'Заполните данные должника',
        savedAfterPayment: 'Данные уйдут в базу только после оплаты',
        debtorName: 'Имя должника',
        debtorNamePlaceholder: 'Как зовут клиента',
        whatsappPhone: 'Номер WhatsApp',
        phonePlaceholder: '8 (XXX) XXX-XX-XX',
        extraPhone: 'Доп. номер',
        addPhone: 'Добавить номер',
        removePhone: 'Удалить номер',
        amount: 'Сумма долга',
        returnDate: 'Дата возврата',
        selectDate: 'Выбрать дату',
        totalDebt: 'Итого к долгу',
        returnBy: 'Вернуть до',
      },
      notifications: {
        cameraNotSupported: 'Камера не поддерживается этим браузером',
        barcodeNotFound: 'Товар по штрихкоду не найден',
        enterDebtorName: 'Укажите имя должника',
        enterDebtorPhone: 'Укажите номер WhatsApp',
        enterDebtAmount: 'Укажите сумму долга',
        enterReturnDate: 'Укажите дату возврата',
        productsLoadFailed: 'Не удалось загрузить товары',
        paymentTypesLoadFailed: 'Не удалось загрузить типы оплаты',
        amountExceedsBonus: 'Сумма превышает бонус',
        enterFullName: 'Укажите ФИО',
        enterPhone: 'Укажите телефон',
        waitForCardNumber: 'Дождитесь номера карты',
        clientAdded: 'Клиент добавлен',
        invalidPayment: 'Неправильная оплата',
        enterSaleAmount: 'Укажите сумму продажи',
        dueTooHigh: 'Сумма не может быть больше суммы товаров ({max})',
        selectProducts: 'Выберите товары',
        enterWeightOrLiter: 'Укажите вес или литр',
        selectPaymentType: 'Выберите тип оплаты',
        enterDebtReturnDate: 'Укажите дату возврата долга',
        findOrAddBonusClient: 'Найдите или добавьте бонус-клиента',
        clientPhoneMissing: 'У клиента не указан телефон',
        paymentSucceeded: 'Оплата прошла',
        insufficientStock: 'На складе недостаточно',
        scaleZeroWeight: 'Весы показали 0. Поставьте товар на чашу',
        weightRead: 'Вес: {value} {unit} ({stability})',
        weightReadFailed: 'Не удалось получить вес. Запустите ves_agent.py',
        weightAutoFilled: 'Вес с весов подставлен: {value} {unit}',
        noStock: 'Нет на складе',
        onlyInStock: 'На складе только {quantity}',
        noStockRestock: 'Нет на складе. Сначала пополните остаток',
      },
    },
  },
}
